/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AdminGetPoolContributionHistoryRequest} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'
import {AdminGetPoolContributionHistoryResponse} from '@cash-web/protos/squareup/cash/pools/v1beta/pools.pb'


export const adminGetPoolContributionHistory = (request:AdminGetPoolContributionHistoryRequest, options?: CashRequestOptions) => post<AdminGetPoolContributionHistoryRequest, AdminGetPoolContributionHistoryResponse>("/2.0/cash/admin-get-pool-contribution-history", request, {...options, rejectOnError: true })